export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const FORM_NAME = 'chosen-comment';

export const REQUIRED_FIELDS = ['comment'];
